import React from "react";
import "./ShimmerCard.css";

const ShimmerCard = () => {
  return (
    <div className="shimmer-card">
      <div className="shimmer shimmer-image"></div>
      <div className="shimmer shimmer-text shimmer-text-1"></div>
      <div className="shimmer shimmer-text shimmer-text-2"></div>
      <div className="shimmer shimmer-colors"></div>
    </div>
  );
};

export default ShimmerCard;
